import { Route, Routes } from 'react-router-dom';
import { AlarmTypeGroupsList } from './alarm-type-groups-list/AlarmTypeGroupsList';

export function AlarmTypeGroupsRoot() {
  return (
    <Routes>
      <Route path="/" element={<AlarmTypeGroupsList />} />
    </Routes>
  );
}

export default AlarmTypeGroupsRoot;
